'use client'

import { SeasonMewContainer } from '@/features/points/SeasonMewContainer'

export default function PointsPage() {
  return <SeasonMewContainer />
}
